import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme)=>({
        container: {
            '&:hover': {
                backgroundColor: theme.tokens.colors.bg.greyscale.secondary
            }
        }
    }));
export { useStyles };
